import FinalFormInputNumber from './FinalFormInputNumber';

export default FinalFormInputNumber;
